module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/PerformancePole-312fce6aeb7d7a69d026fff9b7773dc4.png";